import config from "environment";
import { getRequest, postRequest } from "./client";
import { CreateQuestionForFormPayload, Question, UpdateQuestionConditionsPayload, UpdateQuestionPayload } from "effno-core";

const { baseApi } = config;

export async function apiGetQuestion(id: string) : Promise<Question | null> {
  const fetchURL = `${baseApi}/questions/${id}`;
  return await getRequest(fetchURL, "API/apiGetQuestion");
}

export async function apiGetQuestionsForForm(formId: string) : Promise<Question[] | null> {
  const fetchURL = `${baseApi}/questions/form/${formId}`;
  return await getRequest(fetchURL, "API/apiGetQuestionsForForm");
}

export async function apiCreateQuestionForForm(payload: CreateQuestionForFormPayload) : Promise<Question | null> {
  const fetchURL = `${baseApi}/questions/create-question`;
  return await postRequest(fetchURL, payload, "API/apiCreateQuestionForForm");
}

export async function apiUpdateQuestion(payload: UpdateQuestionPayload) : Promise<Question | null> {
  const fetchURL = `${baseApi}/questions/update-question`;
  return await postRequest(fetchURL, payload, "API/apiUpdateQuestion");
}


export async function apiDeleteQuestion(questionId: string) : Promise<Question | null> {
  const fetchURL = `${baseApi}/questions/delete/${questionId}`;
  return await getRequest(fetchURL, "API/apiDeleteQuestion");
}

export async function apiUpdateQuestionConditions(payload: UpdateQuestionConditionsPayload) : Promise<Question | null> {
  const fetchURL = `${baseApi}/questions/update-conditions`;
  return await postRequest(fetchURL, payload, "API/apiUpdateQuestionConditions");
}


// export async function apiSetUserTheme(userId: string, theme: string) {
//   const fetchURL = `${baseApi}/users/set-theme`;
//   return await postRequest(fetchURL, { userId, theme }, "API/apiSetUserTheme");
// }
